import React, { createRef, Component, Fragment } from "react";
import { getFile } from "../../services/ExternalFileDownloadService";
import { Paths } from "../../constants/UrlConstants";
import { withRouter } from "react-router-dom";
import Contentify from "../../content/Contentify";
import { connect } from "react-redux";
import { setArePopupsBlocked } from "../../features/popups/PopupBlockerActions";
import { wasPopupBlocked } from "../../features/popups/PopupBlockerChecks";
import { Browser } from "../../features/native/NativeBrowserFeatures";
import { Download, pdfFileExtension } from "./Download";
import { redirectToErrorPageMessage } from "../../logging/CommonLogMessages";
import { trackException } from "../../logging/AppInsightsLogger";

export class FileDownload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      downloadLink: ""
    };

    this.hiddenLinkRef = createRef();
  }

  downloadPdf = async (e, fileName, url) => {
    e.preventDefault();
    if (url && fileName) {
      try {
        let response = await getFile(url);
        this.processForPDFDownload(response.data, fileName);
      } catch (error) {
        trackException(
          redirectToErrorPageMessage,
          `Something went wrong while downloading pdf. RequestUrl: ${url} Filename: ${fileName}`
        );
        this.props.history.push(Paths.Error);
      }
    } else {
      trackException(
        redirectToErrorPageMessage,
        `Something went wrong. File name or url might be missing while downloading pdf`
      );
      this.props.history.push(Paths.Error);
    }
  };

  processForPDFDownload = (blobData, fileName) => {
    const blob = new Blob([blobData], { type: "application/pdf" });
    const { setRetryFileUrl } = this.props;
    let url;

    if (Browser.doesSupportURL()) {
      url = URL.createObjectURL(blob);
      if (setRetryFileUrl) {
        setRetryFileUrl(url, blob);
      }
    }

    if (Browser.doesSupportMsSaveBlob()) {
      Download.pdfUsingMsSaveBlob(blob, fileName);
    } else {
      if (
        !this.props.openInNewTab &&
        Browser.doesSupportModernAnchorAttributes()
      ) {
        this.setState({
          downloadLink: url
        });
        this.hiddenLinkRef.current.click();
      } else {
        const arePopupsBlocked = wasPopupBlocked(window.open(url));
        this.props.setArePopupsBlocked(arePopupsBlocked);
      }
    }
  };

  render = () => {
    const { title, children, fileName, url } = this.props;
    const fileDownloadLink = `${fileName}.${pdfFileExtension}`;

    return (
      <Fragment>
        <button
          class={this.props.title==="Download"?"downloadicon":"download"}
          data-file-download
          title={title}
          onClick={(e) => this.downloadPdf(e, fileDownloadLink, url)}
          onKeyPress={(e) => this.downloadPdf(e, fileDownloadLink, url)}
          style={{ cursor: "pointer" }}
          tabindex="0"
        >
          {children}
        </button>
        <a
          data-file-download-hidden-link
          style={{ display: "none" }}
          download={fileDownloadLink}
          href={this.state.downloadLink}
          ref={this.hiddenLinkRef}
        >
          <React.Fragment></React.Fragment>
        </a>
      </Fragment>
    );
  };
}

export default withRouter(
  connect(null, { setArePopupsBlocked })(Contentify(FileDownload))
);
